import { useReducedMotion } from 'motion/react'

// Tactile press motion adapted from beUI's "Motion Button" (https://beui.dev/components/motion/button),
// MIT-licensed (© beUI, https://github.com/starc007/ui-components) — the same vendor-and-adapt pattern
// as the GooeyPopover. A quick, faintly-bouncy scale-down on press that springs back, plus a small hover
// lift on hover-capable devices. Reduced motion collapses it to instant (no transform), like the rest of
// the app. beUI's optional Material ripple is deliberately omitted — the spring-squish alone is the feel.
//
// Deliberately NOT wired into the global Button/PillButton — it's opt-in per component so the press feel
// can be adopted gradually rather than as a wholesale button change. Adopters: the bottom nav's action
// button, and the in-field adornments (SearchField's clear, PasswordField's reveal).

export const PRESS_SPRING = { type: 'spring', stiffness: 500, damping: 30, mass: 0.6 } as const

const PRESS_SCALE = 0.93
const HOVER_SCALE = 1.02

export interface PressMotionProps {
  whileTap?: { scale: number }
  whileHover?: { scale: number }
  transition?: typeof PRESS_SPRING
}

// motion/react props for the tactile press — spread onto any `motion.<element>`. Honors reduced motion.
export function usePressMotion(): PressMotionProps {
  const reduce = useReducedMotion() ?? false
  return reduce ? {} : { whileTap: { scale: PRESS_SCALE }, whileHover: { scale: HOVER_SCALE }, transition: PRESS_SPRING }
}
